import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';
import MediaQuery from 'react-responsive';
import Popover from 'material-ui/Popover';

import Button from '../../Button';
import Icon from '../../Icon';
import Menu from './Menu';

import { COLORS, BREAKPOINT } from '../../../constants/styles';

import styles from './index.styl';

const IconMenu = ({
  className,
  icon,
  items,
  position,
  style,
  btnStyle,
  disabled,
  allScreens,
  onMobilePopover,
  onClick,
  id,
  iconActionMode,
}) => {
  const [isPopoverOpened, togglePopover] = useState(false);
  const [anchorEl, setAnchorEl] = useState();

  const handleTouchTap = event => {
    if (onClick) onClick();
    if (onMobilePopover) onMobilePopover();
    if (!iconActionMode) {
      togglePopover(true);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleRequestClose = () => {
    togglePopover(false);
  };

  const handleSelect = () => {
    handleRequestClose();
  };

  return (
    <div styleName="root" className={className} style={style}>
      <Button
        disabled={disabled}
        icon
        id={id}
        style={btnStyle}
        onClick={handleTouchTap}
        ariaLabel={get(icon, 'name', 'more')}
      >
        <Icon
          name={get(icon, 'name', 'more')}
          size={get(icon, 'size', null)}
          style={{
            fill: get(icon, 'color', COLORS.bluePrimary),
            opacity: disabled ? 0.3 : 1,
          }}
          className="db"
        />
      </Button>
      <MediaQuery minWidth={allScreens ? '0px' : BREAKPOINT}>
        <Popover
          className="popover"
          open={isPopoverOpened}
          anchorEl={anchorEl}
          anchorOrigin={position}
          onClose={handleRequestClose}
        >
          <Menu items={items} onSelect={handleSelect} />
        </Popover>
      </MediaQuery>
    </div>
  );
};

IconMenu.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.shape({
    color: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.number,
  }),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      element: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      onClick: PropTypes.func,
    }),
  ),
  onClick: PropTypes.func,
  position: PropTypes.shape({
    horizontal: PropTypes.string,
    vertical: PropTypes.string,
  }),
  style: PropTypes.object,
  btnStyle: PropTypes.object,
  onMobilePopover: PropTypes.func,
  allScreens: PropTypes.bool,
  iconActionMode: PropTypes.bool,
};

IconMenu.defaultProps = {
  position: {
    horizontal: 'left',
    vertical: 'bottom',
  },
};

export default CSSModules(IconMenu, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/IconMenu/index.jsx